var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrunei(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 23.9983C18.6266 23.9983 23.9984 18.6265 23.9984 12.0001C23.9984 5.37363 18.6266 0.00183105 12.0001 0.00183105C5.37367 0.00183105 0.00187683 5.37363 0.00187683 12.0001C0.00187683 18.6265 5.37367 23.9983 12.0001 23.9983Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60926 6.00088C1.0677 6.93877 0.66822 7.91932 0.402199 8.91811L20.4678 20.5031C21.1998 19.7733 21.8493 18.937 22.3907 17.9991L1.60926 6.00088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9992 1.6092C13.1983 -1.16253 7.27882 -0.238742 3.53216 3.4969L23.5978 15.0818C24.9597 9.9694 22.7999 4.38098 17.9992 1.6092Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00093 22.3908C10.8017 25.1625 16.7213 24.2387 20.4679 20.5031L0.402199 8.91811C-0.959596 14.0306 1.20008 19.6191 6.00093 22.3908Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3909 10.6958C15.3909 12.5685 13.8727 14.0867 12 14.0867C10.1273 14.0867 8.60921 12.5685 8.60921 10.6958C8.60921 10.1119 8.75682 9.56251 9.01679 9.08283C8.28098 9.83533 7.82671 10.8644 7.82671 12C7.82671 14.3048 9.69514 16.1733 12 16.1733C14.3049 16.1733 16.1734 14.3049 16.1734 12C16.1734 10.8644 15.7191 9.83533 14.9833 9.08283C15.2432 9.56261 15.3909 10.1119 15.3909 10.6958Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2176 6.78342H12.7826V14.6084H11.2176V6.78342Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6084 8.34838H9.39175C9.39175 8.70853 9.7055 9.00047 10.0656 9.00047H10.0438C10.0438 9.36062 10.3358 9.65257 10.6959 9.65257C10.6959 10.0127 10.9879 10.3047 11.348 10.3047H12.6522C13.0123 10.3047 13.3043 10.0127 13.3043 9.65257C13.6644 9.65257 13.9564 9.36062 13.9564 9.00047H13.9346C14.2947 9.00043 14.6084 8.70858 14.6084 8.34838Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34848 15.13H15.6518V16.695H8.34848V15.13Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5651 15.6517H16.695V17.2167H13.5651V15.6517Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30516 15.6517H10.4351V17.2167H7.30516V15.6517Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrunei);
export default __webpack_public_path__ + "static/media/brunei.37488c3a4cdabf9fcf21ead27a96d267.svg";
export { ForwardRef as ReactComponent };